const apofinder = {
  landingPage: {
    findPharmacy: 'Apotheke finden',
    subtitle: 'Finden Sie auf IhreApotheken.de tausende Apotheken in Deutschland sowie Apotheken mit Notdienst.',
    scanCode: 'Apotheken-Code scannen',
    tipTitle: 'Medikamente schnell erhalten',
    searchLabel: 'Bitte geben Sie Ihren Standort ein',
    tipBullets: {
      1: '<b>lokale Apotheke</b> wählen',
      2: 'Medikamente <b>online bestellen</b> und Rezepte einlösen',
      3: '<b>Online bezahlen</b>',
      4: 'Bequem nach Hause <b>liefern lassen</b>',
    },
    scan: {
      title: 'Apotheken-Code scannen',
      subtitle: 'Wenn Sie einen Apotheken-Code erhalten haben, können Sie diesen hier scannen. Die entsprechende Apotheke wird als Ihre bevorzugte Apotheke hinterlegt.',
      problem: 'Probleme beim Scannen?',
      tips: {
        mainTitle: 'Tipps zum Scannen',
        title1: 'Wo finde ich den scanbaren Code?',
        title2: 'Welche Codes können gescannt werden?',
        title3: 'Was tun, wenn der Code nicht erkannt wird?',
        content1: 'Den scanbaren Code erhalten Sie von Ihrer lokalen Apotheke. Sprechen Sie einfach das Personal an.',
        content2: 'Die Apotheken-Codes sind spezielle Codes, die Sie nur von den teilnehmenden Apotheken erhalten. Andere QR-Codes werden für die Apothekenauswahl nicht unterstützt.',
        content3: 'Sollte der Code nicht sofort erkannt werden, bewegen oder kippen Sie die Kamera leicht über dem Code. Sie können auch den Abstand verändern. Achten Sie in jedem Fall auf gute Beleuchtung!',
        scanningProblem: 'Andere Probleme beim Scannen?',
        link: 'Melden Sie ein Problem',
        btnClose: 'Schließen',
      },
    },
  },
  apofinderItem: {
    noPreorders: 'Keine Online-Bestellung über diesen Bestellweg möglich',
    noPreordersTooltip: {
      heading: 'Sie werden weitergeleitet',
      content: 'Sie können Ihr (E-)Rezept wie gewohnt in der Apotheke oder in der Gematik-App einlösen.',
    },
    noFreeSpotsTooltip: {
      heading: 'Hier keine Online-Bestellung möglich',
      content: 'An diesem Tag gibt es leider keine verfügbaren Plätze mehr. Bitte passen Sie Ihre Filterkriterien an, um einen freien Termin in dieser Apotheke zu finden.',
    },
    appointmentBooking: 'Termin buchen',
    expressDelivery: 'Express-Botendienstlieferung',
    deliveryPossible: 'Botendienstlieferung möglich',
    pickupAtPharmacy: 'Abholung in der Apotheke',
    onlinePaymentPossible: 'Onlinezahlung möglich',
    requestProduct: 'Produkt anfragen',
    freeSpots: '{spots} freie Plätze',
    freeSpot: '1 freier Platz',
    noFreeSpots: 'Ausgebucht',
    express: 'Express',
    delivery: 'Botendienst',
    onlinePayment: 'Online-Zahlung',
    slotsInHours: '{count} Termine in {hours} Stunden verfügbar',
    slotInHours: '1 Termin in {hours} Stunden verfügbar',
    noSlotsAvailable: 'Keine Termine in den nächsten {hours} Stunden',
    slotsAvailable: 'Termine verfügbar',
    bookAppointment: 'Termin in dieser Apotheke buchen',
  },
  apofinderMap: {
    searchOnMapMove: 'Suche, während ich die Karte bewege',
    filterDropdown: {
      noqLabel: 'Termin buchen in',
      iadeLabel: 'Medikamente bestellen in',
    },
    accordion: {
      title: 'Apotheken in Ihrer Nähe finden',
      answerIade: 'Bitte wählen Sie eine Apotheke aus, bei der Sie bestellen möchten.',
      answerNoq: 'Bitte wählen Sie eine Apotheke aus, bei der Sie einen Termin buchen möchten.',
    },
    openSidebar: 'Seitenleiste öffnen',
    closeSidebar: 'Seitenleiste schließen',
    zoomIn: 'Hineinzoomen',
    zoomOut: 'Rauszoomen',
  },
  apofinderPharmacyList: {
    changePharmacy: 'Apotheke wechseln',
    choosePharmacy: 'Wählen Sie eine andere Apotheke in Ihrer Nähe aus.',
    selectedPharmacy: 'Aktuell ausgewählte Apotheke',
    selectedPharmacyMob: 'Aktuelle Stamm-Apotheke',
    findPharmacy: 'Apotheke finden',
    scanPharmacy: 'Apotheken-Code scannen',
    otherPharmacies: 'Weitere Apotheken in der Nähe',
    showFreeAppointmentsTip: 'Es werden Ihnen freie Termine innerhalb der nächsten 24 Stunden angezeigt.',
    loadMore: 'Mehr laden',
    noPharmacies: 'Keine Apotheken gefunden',
    noResults: {
      title1: 'Suche anpassen',
      content1: 'Es wurde keine Apotheke mit den gesuchten Kriterien gefunden. Bitte passen Sie Ihre Eingabe oder die Filter an.',
      title2: 'Adresse eingeben',
      content2: 'Bitte geben Sie Ihre Adresse ein, damit wir nach Apotheken in Ihrer Nähe suchen können, bei denen Sie Ihre Medikamente Vorbestellung können.',
      content3: 'Bitte geben Sie mehr als 3 Buchstaben ein, damit wir Ihnen Apotheken in Ihrer Nähe vorschlagen können.',
    },
    showSidebarList: 'Zeigen',
    hideSidebarList: 'Verstecken',
  },
  filterTabs: {
    noqLabelShort: 'Terminbuchung',
    noqLabelLong: 'Termin buchen',
    iadeLabel: 'Einkaufen',
  },
  noqModal: {
    title: 'Terminübersicht',
    info: 'Es werden Ihnen freie Termine innerhalb der nächsten {hours} Stunden angezeigt.',
    button: 'Termin buchen',
  },
  apofinderSearchInput: {
    placeholder: 'Bitte geben Sie Ihren Standort ein',
    currentLocation: 'Aktuellen Standort suchen',
    clear: 'Eingabe löschen',
  },
  popper: {
    redirectionTooltip: {
      heading: 'Sie werden weitergeleitet',
      content: 'Sie werden für die Terminbuchung zu unserem Servicepartner No-Q weitergeleitet. Hier können Sie schnell und unkompliziert Termine in Ihrer Apotheke buchen.\n\nGeben Sie eine Adresse oder eine Postleitzahl ein, um Apotheken in Ihrer Umgebung zu finden. Wählen Sie den gewünschten Standort aus, um auf die entsprechende Buchungsseite zu gelangen.',
    },
    deliveryConditions: {
      orderConfirmation: 'Innerhalb von {time} Minuten nach Bestellbestätigung',
      nextDelivery: 'Nächstmöglicher Lieferzeitpunkt',
      pickupTip: 'Ihre Apotheke informiert Sie, sobald das Produkt für Sie abholbereit ist.',
    },
    partners: {
      title: 'Partnerprogramme',
      phytothek: 'Diese Apotheke ist spezialisiert auf pflanzliche Therapie.',
      basica: 'In dieser Apotheke erhalten Sie Basica-Produkte sowie eine umfassende Beratung.',
    },
  },
  onlinePreorder: 'Online bestellen',
  deactivatedPharmacy: 'Diese Apotheke ist leider nicht mehr verfügbar. Bitte wählen Sie eine andere Apotheke aus.',
  deactivatedPharmacySelected: 'Die gewünschte Apotheke ist leider nicht mehr verfügbar. Sie können Ihre gewählte Apotheke beibehalten oder eine andere Apotheke auswählen.',
  camera: {
    error: {
      1: 'Um Ihren Apotheken-Code zu scannen, müssen Sie Ihre Kamera aktivieren. Wie das geht, erfahren Sie',
      2: 'hier',
    },
  },
  qr: {
    error: 'Bitte nutzen Sie einen QR-Code von Ihrer Apotheke. Andere QR-Codes sind leider nicht möglich.',
  },
  maintain: 'Beibehalten',
  cardLink: {
    alert: 'E-Rezepte von Ihrer Gesundheitskarte einlösen? Klicken Sie',
    here: 'hier',
    title: 'E-Rezept von Gesundheitskarte einlösen?',
    descriptionBottomSheet: 'Jetzt auch online bei Ihrer Lieblingsapotheke.  Einfach die App von IhreApotheken.de herunterladen und einlösen.',
    descriptionModal: 'Sie möchten Ihr E-Rezept von Ihrer Gesundheitskarte einlösen? Jetzt auch online bei Ihrer Lieblingsapotheke. Einfach die App von IhreApotheken.de herunterladen und einlösen.',
    step1: 'QR-Code scannen',
    step2: 'App herunterladen',
    step3: 'E-Rezept einlösen',
  },
  pharmacyTypeSelector: {
    title: 'Sie suchen eine Apotheke, die mehr kann?',
    supplierPharmacy: 'Service-Apotheke',
    medicalSupplyPrescriptions: 'Sanitätshaus-Rezepte einlösen',
  },
  laboratoryTests: 'Verkauf von Testsets',
}

export default apofinder
